/**
 * Team Trips — Mobile Drawer Alpine component
 *
 * Controls the bottom-sheet summary drawer shown at < tt-xl (1080px).
 * Features:
 *   - Open / close state
 *   - ESC key to dismiss
 *   - Backdrop click to dismiss
 *   - Focus trap while open (delegates to @alpinejs/focus already registered
 *     in app.js via Alpine.plugin(Focus))
 *
 * Usage in Blade:
 *   <div x-data="mobileDrawer" @keydown.escape.window="close">
 *     <button @click="open">Open summary</button>
 *     <div x-show="isOpen" @click.self="close" ...>
 *       <div x-trap="isOpen" ...> ... </div>
 *     </div>
 *   </div>
 */
export default function mobileDrawer() {
    return {
        /** Whether the drawer is currently visible. */
        isOpen: false,

        /** Open the drawer and lock scroll on the body element. */
        open() {
            this.isOpen = true;
            document.body.style.overflow = 'hidden';
        },

        /** Close the drawer and restore body scroll. */
        close() {
            this.isOpen = false;
            document.body.style.overflow = '';
        },

        /**
         * Toggle open/close state.
         * Registered as @click on the drawer trigger button.
         */
        toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },

        /**
         * Backdrop dismiss handler.
         * Registered as @click.self on the backdrop overlay element so clicks
         * on the drawer content itself do not propagate and dismiss it.
         */
        backdropDismiss() {
            this.close();
        },

        /**
         * Ensure body scroll is restored if Livewire unmounts this component
         * while the drawer is open (e.g. navigation mid-open).
         */
        destroy() {
            document.body.style.overflow = '';
        },
    };
}
